import { motion } from "framer-motion";

const SPECS = [
  { label: "Resistance Range", value: "40 – 99 LB" },
  { label: "Resistance Knobs", value: "5 (Hex Array)" },
  { label: "Adjustment", value: "Tool-Free Dial" },
  { label: "Form Factor", value: "Sphere — Single Unit" },
  { label: "Designed In", value: "Tokyo · 2026" },
  { label: "Series", value: "II" },
];

const Specs = () => {
  return (
    <section id="specs" data-testid="specs-section" className="relative py-24 md:py-32 border-t border-white/10 bg-[#0c0c0c]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 items-start">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-4"
        >
          <div className="text-xs uppercase tracking-[0.3em] text-[#007AFF] mb-4 font-body">// 03 Hardware</div>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            THE SPEC<br/>SHEET.
          </h2>
          <p className="mt-6 text-sm text-white/55 leading-relaxed max-w-sm">
            One sphere. Five knobs. Sixty pounds of dial-in range.
            No tools. No tiers. No fluff.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="lg:col-span-8 border-t border-l border-white/10"
          data-testid="specs-grid"
        >
          <div className="grid grid-cols-1 sm:grid-cols-2">
            {SPECS.map((s) => (
              <div
                key={s.label}
                className="flex items-center justify-between p-5 md:p-6 border-r border-b border-white/10 hover:bg-[#007AFF]/5 transition-colors"
                data-testid={`spec-${s.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              >
                <span className="text-[11px] uppercase tracking-[0.22em] text-white/50 font-body">{s.label}</span>
                <span className="font-heading text-xl tracking-wider">{s.value}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Specs;
